export default "__VITE_ASSET__e7ceeecf__"